/* BLENIN "Complete the look" (2026-09-25, ctl). Markup: snippets/blenin-complete-look.liquid
   1) PDP block: pick a size (and colour), press Add -> cart/add.js with the theme's sections, header count + drawer refresh, drawer opens.
   2) (Off since cart v2, 2026-10-06) Cart drawer step: right after the main product form adds to bag on a product page, the drawer opens with a
      "Complete your look" block at the top (same 2-3 pairings, same pickers) and a "Skip" button. While it shows,
      the drawer's "Pairs well with" cross-sells are hidden. It goes away on Skip or when the drawer closes. */
(function () {
  if (window.blCtl) return;
  window.blCtl = true;

  function sectionEls() {
    return ['page-header', 'cart-drawer'].map(function (s) { return document.querySelector(s); })
      .filter(function (el) { return el && el.dataset && el.dataset.sectionId; });
  }
  function drawer() { return document.querySelector('cart-drawer.js-cart-drawer'); }

  function say(card, text, isError) {
    var m = card.querySelector('.bl-ctl__msg');
    if (!m) return;
    m.textContent = text;
    m.classList.toggle('is-error', !!isError);
    clearTimeout(m._t);
    m._t = setTimeout(function () { m.textContent = ''; }, 4000);
  }

  function selectedId(card) {
    if (card.dataset.singleId) return card.dataset.singleId;
    var b = card.querySelector('.bl-ctl__sizes:not([hidden]) .bl-ctl__size[aria-pressed="true"]');
    return b ? b.dataset.id : null;
  }

  function addToBag(card, btn, inDrawer) {
    var id = selectedId(card);
    if (!id) { say(card, 'Choose a size first.', true); var f = card.querySelector('.bl-ctl__sizes:not([hidden]) .bl-ctl__size:not([disabled])'); if (f) f.focus(); return; }
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-disabled', 'true');
    var els = sectionEls();
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    fd.append('sections_url', window.location.pathname);
    fd.append('sections', els.map(function (el) { return el.dataset.sectionId; }).join(','));
    var url = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    fetch(url, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        var d = res.data || {};
        if (!res.ok || d.status) throw new Error(typeof d.description === 'string' ? d.description : (d.message || 'Could not add to bag. Please try again.'));
        els.forEach(function (el) {
          if (d.sections && d.sections[el.dataset.sectionId] && typeof el.updateFromCartChange === 'function') el.updateFromCartChange(d.sections[el.dataset.sectionId]);
        });
        btn.textContent = 'Added';
        btn.classList.add('is-added');
        say(card, 'Added to bag.');
        setTimeout(function () { btn.textContent = 'Add'; btn.classList.remove('is-added'); }, 2500);
        if (!inDrawer) {
          var dr = drawer();
          if (dr && typeof dr.open === 'function') dr.open(btn);
          else window.location.href = (window.theme && theme.routes && theme.routes.cart) || '/cart';
        }
      })
      .catch(function (err) { say(card, err.message, true); })
      .then(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); });
  }

  function pickSize(btn) {
    var row = btn.closest('.bl-ctl__sizes');
    row.querySelectorAll('.bl-ctl__size').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
  }

  function pickColor(sel) {
    var card = sel.closest('[data-bl-ctl-card]');
    var val = sel.value;
    card.querySelectorAll('.bl-ctl__sizes[data-color]').forEach(function (r) {
      r.hidden = r.dataset.color !== val;
      if (r.hidden) r.querySelectorAll('.bl-ctl__size').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    });
    var opt = sel.options[sel.selectedIndex];
    var img = card.querySelector('.bl-ctl__img');
    if (img && opt && opt.dataset.img) { img.removeAttribute('srcset'); img.src = opt.dataset.img; }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.bl-ctl__size, [data-bl-ctl-add], [data-bl-ctl-skip]');
    if (!t) return;
    if (t.matches('[data-bl-ctl-skip]')) { e.preventDefault(); hideStep(true); return; }
    var card = t.closest('[data-bl-ctl-card]');
    if (!card) return;
    e.preventDefault();
    if (t.classList.contains('bl-ctl__size')) { if (!t.disabled) pickSize(t); return; }
    addToBag(card, t, !!t.closest('cart-drawer'));
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-bl-ctl-color]')) pickColor(e.target);
  });

  /* ---------- Cart drawer step ---------- */
  var STEP_ID = 'bl-ctl-step';

  function hideStep(focusBag) {
    var step = document.getElementById(STEP_ID);
    var dr = drawer();
    if (dr) dr.classList.remove('bl-ctl-on');
    if (!step) return;
    step.remove();
    if (focusBag && dr) {
      var title = dr.querySelector('#CartDrawerModal-Title');
      var first = dr.querySelector('.cart-item a, .cart-item button, .js-close-drawer');
      if (title) { title.setAttribute('tabindex', '-1'); title.focus({ preventScroll: true }); }
      else if (first) first.focus({ preventScroll: true });
    }
  }

  function showStep(root) {
    var dr = drawer();
    if (!dr || !root) return;
    var upper = dr.querySelector('.cart-drawer__content-upper');
    var header = upper && upper.querySelector('.cart-drawer__header');
    if (!upper) return;
    hideStep(false);
    var list = root.querySelector('[data-bl-ctl-list]');
    if (!list) return;
    var step = document.createElement('section');
    step.id = STEP_ID;
    step.className = 'bl-ctl bl-ctl--drawer cart-drawer__content-item';
    step.setAttribute('aria-labelledby', STEP_ID + '-h');
    step.innerHTML = '<div class="bl-ctl__top"><h2 class="bl-ctl__heading" id="' + STEP_ID + '-h">Complete your look</h2>' +
      '<button type="button" class="bl-ctl__skip" data-bl-ctl-skip>Skip<span class="visually-hidden"> and see your bag</span></button></div>';
    var clone = list.cloneNode(true);
    // Fresh state + unique ids for the cloned colour selects.
    clone.querySelectorAll('.bl-ctl__size').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    clone.querySelectorAll('.bl-ctl__msg').forEach(function (m) { m.textContent = ''; });
    clone.querySelectorAll('[data-bl-ctl-add]').forEach(function (b) { b.textContent = 'Add'; b.classList.remove('is-added', 'is-loading'); });
    clone.querySelectorAll('select[id]').forEach(function (s) {
      var lab = clone.querySelector('label[for="' + s.id + '"]');
      s.id = s.id + '-d';
      if (lab) lab.setAttribute('for', s.id);
    });
    step.appendChild(clone);
    if (header && header.nextSibling) upper.insertBefore(step, header.nextSibling);
    else upper.insertBefore(step, upper.firstChild);
    dr.classList.add('bl-ctl-on');
  }

  // Cart v2 (2026-10-06): the "Complete your look" drawer step is off. The drawer now shows the added item first and
  // "Goes well with" under it (snippets/blenin-cart-recs.liquid, assets/blenin-cart.js). The PDP block above is unchanged.

  // Remove the step once the drawer has slid out (not mid-animation); keep it if the drawer was reopened.
  document.addEventListener('on:cart-drawer:before-close', function () {
    setTimeout(function () { var dr = drawer(); if (!dr || !dr.hasAttribute('open')) hideStep(false); }, 450);
  });
})();
